import { TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.common.white}`,
  maxHeight: '600px',
  maxWidth: '100%',
  overflowX: 'auto',
  overflowY: 'auto',
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}));

export const StyledHeaderCell = styled(TableCell)<{ isHighlighted?: boolean }>(
  ({ theme, isHighlighted }) => ({
    fontWeight: isHighlighted ? 700 : 600,
    fontSize: theme.spacing(2.25),
    color: theme.palette.text.primary,
    borderBottom: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    whiteSpace: 'nowrap',
    backgroundColor: isHighlighted ? theme.palette.grey[100] : theme.palette.common.white,
    minWidth: '150px',
    textAlign: 'center',
  })
);

export const VariableHeaderCell = styled(StyledHeaderCell)(({ theme }) => ({
  width: '300px',
  minWidth: '300px',
  maxWidth: '300px',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  textAlign: 'start',
  fontSize: theme.spacing(2.25),
  fontWeight: theme.typography.subtitle1.fontWeight,
}));

export const StyledTableCell = styled(TableCell)<{ isHighlighted?: boolean }>(
  ({ theme, isHighlighted }) => ({
    fontSize: '14px',
    fontWeight: isHighlighted ? 700 : 600,
    color: theme.palette.text.primary,
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    whiteSpace: 'nowrap',
    minWidth: '150px',
    textAlign: 'center',
    backgroundColor: isHighlighted ? theme.palette.grey[100] : 'transparent',
  })
);

export const VariableTableCell = styled(StyledTableCell)(() => ({
  fontWeight: 600,
  width: '300px',
  minWidth: '300px',
  maxWidth: '300px',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  textAlign: 'start',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td': {
    borderBottom: 0,
  },
}));
